/**
 * Footnotes Table Component
 *
 * Table component for displaying and managing footnotes with inline editing capabilities.
 */

import './FootnotesTable.scss';

import { ColDef } from '@amzn/gft-ag-grid-enterprise';
import { AurigaGrid } from '@components/Common/AurigaGrid/AurigaGrid';
import { globalGridDefaults } from '@constants/agGrid';
import { FootnotesTableProps, FootnoteTableRow } from 'types/Footnotes.types';

import {
  DeleteCellRenderer,
  DescriptionCellRenderer,
  IdCellRenderer,
  LinkedCellRenderer,
} from './FootnotesTableRowCellRenderers';

const FootnotesTable = ({ data, onUpdateRow, onDeleteRow, isEditingDisabled }: FootnotesTableProps) => {
  const columnDefs: ColDef<FootnoteTableRow>[] = [
    {
      field: 'linked',
      headerName: 'Linked',
      width: 100,
      resizable: false,
      cellRenderer: LinkedCellRenderer,
      cellRendererParams: {
        onChange: (rowId: string, linked: boolean) => onUpdateRow(rowId, { linked }),
        isEditingDisabled,
      },
    },
    {
      field: 'footnoteNo',
      headerName: 'ID',
      width: 80,
      cellRenderer: IdCellRenderer,
    },
    {
      field: 'description',
      headerName: 'Footnote',
      flex: 1,
      cellRenderer: DescriptionCellRenderer,
      cellRendererParams: {
        onChange: (rowId: string, description: string) => onUpdateRow(rowId, { description }),
        isEditingDisabled,
      },
    },
    {
      field: 'id',
      headerName: 'Delete',
      width: 100,
      cellRenderer: DeleteCellRenderer,
      resizable: false,
      cellRendererParams: {
        onDelete: (rowId: string) => onDeleteRow(rowId),
        isEditingDisabled,
      },
    },
  ];

  return (
    <div className='footnotes-table ag-theme-material'>
      <AurigaGrid
        {...globalGridDefaults}
        rowData={data}
        columnDefs={columnDefs}
        domLayout='autoHeight'
        getRowId={(params) => params.data.id}
      />
    </div>
  );
};

export default FootnotesTable;
